import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'withdraw-coinbase.component',
  templateUrl: '../sharedTemplates/withdraw-coinbase.component.html',
})
export class WithdrawCoinbaseComponent implements OnInit {
  coinbaseWithdrawDatas: UntypedFormGroup;
  coinbaseDataRaw: any;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper
  ) {
    this.coinbaseWithdrawDatas = _FormBuilder.group({
      withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(10)]),
      bitcoinAddress: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit() {
    this.coinbaseWithdrawDatas.valueChanges.subscribe(x => {
      this.coinbaseDataRaw = x;
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Bitcoin', true);
  }

  submitCoinbaseWithdrawData() {
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.withdrawCoinBase(this.coinbaseDataRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      ////console.log("COIN_BASE_WITHDRAW", result);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          //window.location = result.message;

          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.successSnackBar(t_message, '');
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
